import { Directive, Input, inject } from '@angular/core';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { Basket } from '@df/session/api/basket/basket';
import { PriceService } from '@df/ui/price/price.service';
import keys from 'lodash-es/keys';
import pick from 'lodash-es/pick';
import values from 'lodash-es/values';

export namespace NBasketFreeShipping {
    export interface IFreeshipping {
        [method: string]: boolean;
    }

    export interface IFreeshippingminamount {
        name: string;
        value: number;
    }

    export interface IFreeshippingminamountExt extends IFreeshippingminamount {
        isFullfilled: boolean;
        neededValue: number;
    }
}

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketData {
            freeshippingminamounts?: NBasketFreeShipping.IFreeshippingminamount[];
            freeshipping?: NBasketFreeShipping.IFreeshipping;
        }
    }
}

@Directive()
export class BasketFreeDeliveryNoticeComponentDef extends AbstractBasketComponent<Basket> {
    /**
     * Synced rules prepared in every change detection
     */
    protected rules: NBasketFreeShipping.IFreeshippingminamountExt[] | undefined;

    /**
     * Price service
     */
    private priceService = inject(PriceService);

    @Input()
    subtotalWithDiscount = false;

    override ngOnInit(): void {
        this.updateRules();
        super.ngOnInit();
    }

    /**
     * If rule is fullfilled test
     */
    protected isFullfilled(rule: NBasketFreeShipping.IFreeshippingminamount): boolean {
        return this.basket.data.totals ? rule.value <= this.subtotalValue : false;
    }

    /**
     * Prepares prices string
     */
    protected toPriceString(value: number): string | undefined {
        return this.priceService.toPlainString(value);
    }

    override detectChanges(): void {
        this.updateRules();
        super.detectChanges();
    }

    protected get subtotalValue() {
        return this.subtotalWithDiscount ? this.basket.subtotalWithDiscount : this.basket.subtotal;
    }

    /**
     * Retrieves list of free shiepping rules applicable for the basket
     */
    private getRules(): NBasketFreeShipping.IFreeshippingminamountExt[] | undefined {
        if (!this.basket.qty) {
            return;
        }
        const basketData = this.basket.data;
        return (
            basketData.freeshippingminamounts &&
            basketData.freeshipping &&
            values(pick(basketData.freeshippingminamounts, keys(basketData.freeshipping)))
                .filter(rule => !!rule)
                .map(rule => {
                    const isFullfilled = this.isFullfilled(rule!);
                    return {
                        ...rule!,
                        isFullfilled,
                        neededValue: isFullfilled ? 0 : rule!.value - this.subtotalValue
                    };
                })
        );
    }

    private updateRules(): void {
        this.rules = this.getRules();
    }
}
